import { render } from "./QuestionGdprScreen.vue?vue&type=template&id=ac5e2a4c&scoped=true&lang=html"
import script from "./QuestionGdprScreen.vue?vue&type=script&lang=js"
export * from "./QuestionGdprScreen.vue?vue&type=script&lang=js"

import "./QuestionGdprScreen.vue?vue&type=style&index=0&id=ac5e2a4c&lang=scss&scoped=true"

import exportComponent from "/Users/peterdevos/Apps/clawmachine_rodi/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac5e2a4c"]])

export default __exports__